import React from 'react';
import { ccyFormat } from '../../helpers/helper';

const EtiquetaCustom = ({ producto, precio }) => {
  return (
    <div style={{
      border: '1px solid black',
      padding: 0,
      margin: 0,
      width: '250px',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
    }}>
      <h2 style={{ margin: 0 }} >{producto}</h2>
      <h1 style={{ margin: 0 }}>${ccyFormat(precio)}</h1>
    </div>
  );
};

export default EtiquetaCustom;
